import { render, staticRenderFns } from "./AchievementItem.vue?vue&type=template&id=27f3867a&scoped=true"
import script from "./AchievementItem.vue?vue&type=script&lang=js"
export * from "./AchievementItem.vue?vue&type=script&lang=js"
import style0 from "./AchievementItem.vue?vue&type=style&index=0&id=27f3867a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f3867a",
  null
  
)

export default component.exports